import { EnumStringHelper } from '@zajno/common/structures/helpers/enum';
import { Database } from '../db.ts';
import { StatusHistory } from './common/history.ts';
import { ProductData } from './product.ts';
import { PurchaseRawData } from './purchase.ts';
import { UserProfile } from './user.ts';

type DBCampaign = Database['public']['Tables']['campaigns']['Row'];

export type CampaignRawData = Omit<DBCampaign, 'status' | 'status_history' | 'product' | 'purchase' | 'playlists'> & {
    status: CampaignStatus;
    status_history?: StatusHistory<CampaignStatus>;
    product: ProductData;
    purchase: CampaignPurchase;
    playlists: CampaignPlaylists;
};

export type CampaignPlaylists = {
    links: string[];
};

export type CampaignPurchase = Omit<PurchaseRawData, 'stripe'>;

export type CampaignData = CampaignRawData & {
    productRef: ProductData;
    purchaseRef?: PurchaseRawData;
    user?: UserProfile;
};

export enum CampaignStatus {
    Pending = 'pending',
    Hold = 'hold',
    Active = 'active',
    Canceled = 'canceled',
    Approved = 'approved',
    Completed = 'completed',
    Refunded = 'refunded',
    Disputed = 'disputed'
}

export namespace CampaignStatus {
    export const Helper = new EnumStringHelper<CampaignStatus>(CampaignStatus);
}

export type CampaignMainInfoUpdateData = {
    name: string,
    email: string,
    guaranteedStream: number,
};
